import { Component, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  isSidebarHidden = false;

  private router = inject(Router);
  private route = inject(ActivatedRoute);

  private isPublicRouteSubject = new BehaviorSubject<boolean>(this.computeIsPublic());
  isPublicRoute$ = this.isPublicRouteSubject.asObservable();

  ngOnInit(): void {
    this.isSidebarHidden = localStorage.getItem('layout:sidebar-hidden') === '1';

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => {
        const v = this.computeIsPublic();
        if (v !== this.isPublicRouteSubject.value) {
          this.isPublicRouteSubject.next(v);
        }
      });
  }

  private computeIsPublic(): boolean {
    let r: ActivatedRoute | null = this.route;
    while (r) {
      if (r.snapshot.data?.['public']) return true;
      r = r.firstChild ?? null;
    }
    return this.router.url?.startsWith('/auth') ?? false;
  }

  onToggleSidebar(): void {
    this.isSidebarHidden = !this.isSidebarHidden;
    localStorage.setItem('layout:sidebar-hidden', this.isSidebarHidden ? '1' : '0');
  }
}
